import React, { FC, PropsWithChildren } from 'react';
import { useRouteError } from 'react-router-dom';
import ErrorView from 'Components/ErrorBoundary/ErrorView';

const ErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  const error = useRouteError();

  if (error) {
    return <ErrorView />;
  }

  return <>{children}</>;
};

export default ErrorBoundary;
